module.exports = __webpack_public_path__ + "static/media/photo-2.34732a74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-extension/photo-2.jpg
// module id = 168
// module chunks = 0